var exports = {
  "_G": "x8b4e8595--3bc466--custom-container",
  "EY": "x8b4e8595--3bc466--custom-content",
  "lq": "x8b4e8595--3bc466--footer-button",
};

module.exports = exports;
